import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  greenLight: {
    backgroundColor: theme.colorPalette.green_75_op_75
  },
  green: {
    backgroundColor: theme.colorPalette.green_100
  },
  orange: {
    backgroundColor: theme.colors.notice_background
  },
  red: {
    backgroundColor: theme.colorPalette.red_100
  },
  bannerShow: {
    width: '100%',
    padding: '0px 15px',
    borderRadius: 0,
    // Banners stay dark in the reskin, so their text stays light.
    color: theme.colorPalette.beige_50,
    ...reskinStyles(theme, { border: 'none' }),
    animation: '$fadeIn 1s',
    minHeight: 58
  },
  '@keyframes fadeIn': {
    '0%': {
      visibility: 'hidden',
      transform: 'translateY(-200%)'
    },
    '100%': {
      visibility: 'visible',
      transform: 'translateY(0)'
    }
  },
  icon: {
    marginRight: 16,
    width: 50,
    height: 30
  },
  bannerContent: {
    width: '94%',
    minHeight: 58
  }
}));

export default useStyles;
